import SxSViewState, { RightPaneDisplay } from '../store/schema/SxSViewState';
import { action } from 'satcheljs';

const setPanesSize = action(
    'setPanesSize',
    (viewState: SxSViewState, leftPaneDimension: number, rightPaneDimension: number) => ({
        viewState,
        leftPaneDimension,
        rightPaneDimension,
    })
);

const setRightPaneDisplay = action(
    'setRightPaneDisplay',
    (viewState: SxSViewState, rightPaneDisplay: RightPaneDisplay) => ({
        viewState,
        rightPaneDisplay,
    })
);

const setRightPaneDisplayAndUpdateSize = action(
    'setRightPaneDisplayAndUpdateSize',
    (
        viewState: SxSViewState,
        readingPaneDisplay: RightPaneDisplay,
        parentElementWidth?: number
    ) => ({
        viewState,
        readingPaneDisplay,
        parentElementWidth,
    })
);

const updatePanesSize = action(
    'updatePanesSize',
    (viewState: SxSViewState, parentElementWidth: number) => ({
        viewState,
        parentElementWidth,
    })
);

export { setPanesSize, setRightPaneDisplay, setRightPaneDisplayAndUpdateSize, updatePanesSize };
